// The window.open names of every detached TeamX window, in one place.
//
// A name is how a window is found again: closeNamedWindow and
// focusNamedWindow call window.open('', name), which *creates* a blank window
// when nothing carries that name. So a misspelt name does not fail quietly -
// it opens a stray pop-up, closes it, and leaves the real window open. That is
// what happened at logout while App.js, UserHub.js and Announcement.js each
// kept their own spelling of these.
export const CHAT_WINDOW = 'chatBoxWindow';
export const BULLETIN_WINDOW = 'Bulletin';
export const USER_MANAGER_WINDOW = 'User Manager';
export const GROUP_MANAGER_WINDOW = 'Group Manager';
export const QUOTE_MANAGER_WINDOW = 'Quote Manager';
export const MAKE_ANNOUNCEMENT_WINDOW = 'Make Announcement';

// Each received announcement gets a window of its own. A shared name made a
// second announcement load into the first one's window.
export const announcementWindowName = (announcementId) => 'Announcement-' + announcementId;

// The windows whose names are fixed. Announcement windows are per message, so
// whoever holds the announcements closes those.
export const FIXED_CHILD_WINDOWS = [
  CHAT_WINDOW,
  BULLETIN_WINDOW,
  USER_MANAGER_WINDOW,
  GROUP_MANAGER_WINDOW,
  QUOTE_MANAGER_WINDOW,
  MAKE_ANNOUNCEMENT_WINDOW,
];



// WEBPACK FOOTER //
// ./src/utils/windowNames.js